import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Switch } from "@headlessui/react";
import { FaBug } from "react-icons/fa";
import { setDebugMode } from "../../store/slices/userSlice";
import { setMinDartRounds } from "../../store/slices/dartSlice";
import NotificationTest from "../NotificationTest";

const DebugModeSection = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { debugMode } = useSelector((state) => state.user);

  const handleDebugModeToggle = (enabled) => {
    dispatch(setDebugMode(enabled));
  };

  return (
    <section className="bg-secondary p-6 rounded-2xl shadow-lg">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <FaBug className="text-test" size={20} />
          <div>
            <h2 className="text-xl font-semibold text-test">
              {t("settings.debugMode.title")}
            </h2>
            <p className="text-white/60 text-sm">
              {t("settings.debugMode.description")}
            </p>
          </div>
        </div>
        <Switch
          checked={debugMode}
          onChange={handleDebugModeToggle}
          className={`${
            debugMode ? "bg-test" : "bg-primary"
          } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-test focus:ring-offset-2 focus:ring-offset-secondary`}
        >
          <span className="sr-only">Enable debug mode</span>
          <span
            className={`${
              debugMode ? "translate-x-6" : "translate-x-1"
            } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
          />
        </Switch>
      </div>
    </section>
  );
};

const MinimumRoundsSection = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [showMinDarts, setShowMinDarts] = useState(false);

  const handleMinDartChange = (e) => {
    dispatch(setMinDartRounds(Number(e.target.value)));
  };

  return (
    <section className="bg-secondary p-6 rounded-2xl shadow-lg">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold text-test">
          {t("settings.minimumRounds.title")}
        </h2>
        <Switch
          checked={showMinDarts}
          onChange={setShowMinDarts}
          className={`${
            showMinDarts ? "bg-test" : "bg-primary"
          } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none`}
        >
          <span className="sr-only">Toggle Minimum Rounds</span>
          <span
            className={`${
              showMinDarts ? "translate-x-6" : "translate-x-1"
            } inline-block h-4 w-4 transform bg-white rounded-full transition-transform`}
          />
        </Switch>
      </div>
      {showMinDarts && (
        <div className="mt-4">
          <label className="block mb-1 text-white">
            {t("settings.minimumRounds.description")}
          </label>
          <input
            type="number"
            onChange={handleMinDartChange}
            className="w-full bg-primary border border-lightGray text-white rounded-lg px-3 py-2 focus:border-test focus:outline-none"
            placeholder={t("settings.minimumRounds.placeholder")}
          />
          <p className="text-white/60 text-sm mt-2">
            {t("settings.minimumRounds.default")}
          </p>
        </div>
      )}
    </section>
  );
};

const AdminSection = () => {
  return (
    <div className="space-y-8">
      <DebugModeSection />
      <NotificationTest />
      <MinimumRoundsSection />
    </div>
  );
};

export default AdminSection;
